import React, { createContext, useReducer } from "react";
import programsReducer, { initialPrograms } from "./ProgramsReducer";

const ProgramsContext = createContext();

const ProgramsProvider = ({ children }) =>{
    const [programsState, dispatch] = useReducer(programsReducer, initialPrograms);
    return(
        <ProgramsContext.Provider value={[programsState, dispatch]}>
            {children}
        </ProgramsContext.Provider>
    );
}

export { ProgramsContext }
export default ProgramsProvider;